import MutationTypes from '../../MutationTypes';

export default {
    [MutationTypes.SET_IS_LOADING]: (state, payload) => {
        state.isLoading = payload;
    },
    [MutationTypes.SET_IS_ALERT]: (state, payload) => {
        state.alert = payload;
    },
    [MutationTypes.SET_IS_DATA]: (state, payload) => {
        state.data = payload;
    }
};
